import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PredictionResult = ({ historicalData, predictedData }) => {
  // Combine historical and predicted data for visualization
  const combinedData = [
    ...historicalData,
    ...predictedData.map(item => ({ ...item, isPrediction: true }))
  ];

  // Custom tooltip to format the price in INR for 8g gold
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{ 
          backgroundColor: 'white', 
          padding: '10px', 
          border: '1px solid #ccc',
          borderRadius: '5px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <p className="label" style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>{`Date: ${label}`}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ 
              margin: '0', 
              color: entry.name.includes('Historical') ? '#341539' : '#FF4500',
              fontWeight: '500'
            }}>
              {`${entry.name}: ₹${entry.value.toLocaleString('en-IN')}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="prediction-result">
      <h2>
        Gold Price Prediction 
        <span className="currency-badge">INR</span>
        <span className="weight-badge">8g</span>
      </h2>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={combinedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            tick={{ fill: '#333' }}
            tickLine={{ stroke: '#333' }}
          />
          <YAxis 
            tick={{ fill: '#333' }}
            tickLine={{ stroke: '#333' }}
            domain={[70000, 'auto']}
            tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="price"
            stroke="#341539"
            strokeWidth={2}
            dot={{ r: 3, fill: '#341539', stroke: '#240e29' }}
            activeDot={{ r: 8, fill: '#4e2255', stroke: '#240e29' }}
            name="Historical Price (8g)"
            connectNulls
          />
          <Line
            type="monotone"
            dataKey="predictedPrice"
            stroke="#FF4500"
            strokeWidth={2}
            dot={{ r: 3, fill: '#FF4500', stroke: '#FF8C00' }}
            activeDot={{ r: 8, fill: '#FF8C00', stroke: '#FF4500' }}
            name="Predicted Price (8g)"
            connectNulls
            strokeDasharray="5 5"
          />
        </LineChart>
      </ResponsiveContainer>
      
      <div className="prediction-table">
        <h3>Predicted Gold Prices (8g)</h3>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Predicted Price (INR)</th>
            </tr>
          </thead>
          <tbody>
            {predictedData.map((item, index) => (
              <tr key={index}>
                <td>{item.date}</td>
                <td>₹{item.predictedPrice.toLocaleString('en-IN')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PredictionResult;